import React, { ReactNode, useRef } from "react";
import "./OverlaySlide.scss";
import { ISlideContent } from "../../../../interfaces/SlideContent";
import { OverlaySlideBackground } from "./OverlaySlideBackground/OverlaySlideBackground";
import { CloseButton } from "../../../../components/CloseButton/CloseButton";
import { SlideHeaderButton } from "./SlideHeaderButton/SlideHeaderButton";
import { useTranslation } from "react-i18next";
import { OverlaySlideImages } from "./OverlaySlideImages/OverlaySlideImages";
import { CustomTouchScroll } from "../../../../components/CustomTouchScroll/CustomTouchScroll";
// import { Image3DSlider } from "./Image3DSlider/Image3DSlider";

interface IProps {
    content: ISlideContent
    onClose: () => void
    closeOnPrevious?: boolean
    onPrevious?: { buttonText: string, buttonHandle: () => void }
    onNext?: { buttonText: string, buttonHandle: () => void }
}

export function OverlaySlide({ content, onClose, closeOnPrevious, onPrevious, onNext }: IProps) {
    const textContentContainerRef = useRef<HTMLDivElement>(null);
    const { t } = useTranslation();
    const size = content.images ? 'full' : 'half';

    const headerButtons: ReactNode[] = [];
    if (closeOnPrevious) {
        headerButtons.push(<SlideHeaderButton key={0} variant={'close'} onClick={onClose}><span>{t('generic.previous')}</span></SlideHeaderButton>);
    }
    if (onPrevious) {
        const { buttonText, buttonHandle } = onPrevious;
        headerButtons.push(<SlideHeaderButton key={1} variant={'previous'} onClick={buttonHandle}><small>{t('generic.page')}</small><span>{buttonText}</span></SlideHeaderButton>)
    }
    if (onNext) {
        const { buttonText, buttonHandle } = onNext;
        headerButtons.push(<SlideHeaderButton key={2} variant={'next'} onClick={buttonHandle}><small>{t('generic.page')}</small><span>{buttonText}</span></SlideHeaderButton>)
    }

    return (
        <div className={`overlay-slide-wrapper ${size}`}>
            <OverlaySlideBackground />
            {headerButtons}
            <div className="overlay-slide-content">
                <h5>ACE Playground ////</h5>
                <h1>{content.title}</h1>
                {/*<ScrollBall />*/}
                <CustomTouchScroll className="text-content-container">
                    <div className="text-content" dangerouslySetInnerHTML={{__html: content.content}} />
                </CustomTouchScroll>
                {/*<div ref={textContentContainerRef}>*/}
                {/*    */}
                {/*</div>*/}
            </div>
            {content.images ? <OverlaySlideImages images={content.images} /> : <></>}
            <div className="overlay-close-button-wrapper">
                <CloseButton onClick={onClose} />
            </div>
        </div>
    )
}
